import { useMutation } from '@tanstack/react-query'
import { contactListApi } from '../lib/api'
import type { GuidedListSpec } from '../types/guidedList'

/** Compile a GuidedListSpec into FilterGroups. Callers debounce spec changes before calling mutate. */
export function useCompileGuidedList() {
  return useMutation({
    mutationFn: (spec: GuidedListSpec) => contactListApi.compileGuided(spec).then(r => r.data.filterGroups),
  })
}
